import { GridContext } from "@made-people/blueprint-grid";
import { StoryblokComponentList } from "@made-people/grease-storyblok";

import type { CSSProperties } from "react";
import type { SbBlokData } from "@storyblok/js";
import {
  ProductListCellMetrics,
  ProductListCellMetricsContext,
} from "@made-people/blueprint-product-list";

export interface ProductListContentCellProps {
  components: SbBlokData[];
  metrics?: ProductListCellMetrics;
  spannedColumns?: number;
  spannedRows?: number;
}

export const ProductListContentCell = ({
  components,
  metrics,
  spannedColumns = 1,
  spannedRows = 1,
}: ProductListContentCellProps) => {
  const bannerHeight = `calc((100cqw - (${spannedColumns} - 1) * var(--component-spacing-xl)) / ${spannedColumns} * 7 / 5 * ${spannedRows} + (${spannedRows} - 1) * var(--component-spacing-xl))`;

  return (
    <GridContext.Provider value={true}>
      <ProductListCellMetricsContext.Provider value={metrics}>
        <div
          className="grid h-full w-full [container-type:inline-size] [&>*]:h-full [&>*]:w-full"
          style={{ "--plp-banner-height": bannerHeight } as CSSProperties}
        >
          <StoryblokComponentList components={components} />
        </div>
      </ProductListCellMetricsContext.Provider>
    </GridContext.Provider>
  );
};
